import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
var useCountdown = function useCountdown(expireDate, skip) {
  var refInterval = useRef(0);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    remainingTimeinMilliseconds = _useState2[0],
    setRemainingTimeinMilliseconds = _useState2[1];
  var _useState3 = useState({
      value: '99',
      raw: 99
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    days = _useState4[0],
    setDays = _useState4[1];
  var _useState5 = useState('99'),
    _useState6 = _slicedToArray(_useState5, 2),
    hours = _useState6[0],
    setHours = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    rawHours = _useState8[0],
    setRawHours = _useState8[1];
  var _useState9 = useState('99'),
    _useState0 = _slicedToArray(_useState9, 2),
    totalHours = _useState0[0],
    setTotalHours = _useState0[1];
  var _useState1 = useState('00'),
    _useState10 = _slicedToArray(_useState1, 2),
    minutes = _useState10[0],
    setMinutes = _useState10[1];
  var _useState11 = useState('00'),
    _useState12 = _slicedToArray(_useState11, 2),
    seconds = _useState12[0],
    setSeconds = _useState12[1];
  var _useState13 = useState(expireDate ? expireDate.getTime() <= new Date().getTime() : true),
    _useState14 = _slicedToArray(_useState13, 2),
    finished = _useState14[0],
    setFinished = _useState14[1];
  var updateCountdown = function updateCountdown(dateExpired) {
    var nowDate = new Date().getTime();
    var timeLeftinMilliseconds = dateExpired.getTime() - nowDate;
    var rawDaysLeft = Math.floor(timeLeftinMilliseconds / (1000 * 60 * 60 * 24));
    var daysLeft = "0".concat(rawDaysLeft).slice(-2);
    var totalHrs = Math.floor(timeLeftinMilliseconds / (1000 * 60 * 60));
    var rawHoursLeft = totalHrs > 23 ? totalHrs % 24 : totalHrs;
    var hoursLeft = "0".concat((totalHrs > 23 ? totalHrs % 24 : totalHrs).toString()).slice(-2);
    var minutesLeft = "0".concat(Math.floor(timeLeftinMilliseconds % (1000 * 60 * 60) / (1000 * 60)).toString()).slice(-2);
    var secondsLeft = "0".concat(Math.floor(timeLeftinMilliseconds % (1000 * 60) / 1000).toString()).slice(-2);
    setRemainingTimeinMilliseconds(timeLeftinMilliseconds);
    setDays({
      value: daysLeft,
      raw: rawDaysLeft
    });
    setTotalHours(totalHrs.toString().length < 2 ? "0".concat(totalHrs.toString()) : totalHrs.toString());
    setHours(hoursLeft);
    setRawHours(rawHoursLeft);
    setMinutes(minutesLeft);
    setSeconds(secondsLeft);
    if (timeLeftinMilliseconds <= 0) {
      clearInterval(refInterval.current);
      setFinished(true);
    }
  };

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    var isFinished = expireDate ? expireDate.getTime() <= new Date().getTime() : true;
    setFinished(isFinished);
    if (expireDate && !skip && !isFinished) {
      refInterval.current = window.setInterval(function () {
        updateCountdown(expireDate);
      }, 1000);
      updateCountdown(expireDate);
    } else if (refInterval.current) {
      clearInterval(refInterval.current);
    }
    return function () {
      return clearInterval(refInterval.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expireDate ? expireDate.toISOString() : '', skip]);
  return {
    remainingTimeinMilliseconds: remainingTimeinMilliseconds,
    days: days.value,
    rawDays: days.raw,
    totalHours: totalHours,
    rawHours: rawHours,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    hasStarted: hours !== '99',
    finished: finished
  };
};
export default useCountdown;